import { useMemo } from "react";
import { v4 as uuid } from "uuid";
import { FCX, getScaledPixels, useWindowSizeDebounced } from "@datassential/platform-ui-lib";
import TableHead from "@components/Table/TableHead";
import TableRow from "@components/Table/TableRow";
import cn from "classnames";

const Table: FCX<{
    isLoading?: boolean;
    rowsCount: number;
    headHeight?: number;
    rowHeight?: number;
    noHeader?: boolean;
}> = ({
    isLoading,
    rowsCount,
    headHeight = 38,
    rowHeight = 38,
    noHeader = false,
    style,
    className,
    children,
    testId,
}) => {
    const [wWidth] = useWindowSizeDebounced();
    const data = useMemo(
        () => Array(rowsCount).fill(0).map(() => uuid()),
        [rowsCount]
    );

    return (
        <div
            className={cn("Table", className )}
            style={style}
            data-testid={testId}
        >
            {!noHeader && <TableHead height={headHeight}/>}
            {data.map((row, index) => (
                <TableRow
                    key={row}
                    index={index}
                    isLoading={isLoading}
                    testId={`tableRow${index}`}
                    style={{
                        height: getScaledPixels(rowHeight, wWidth),
                    }}
                />
            ))}
            {children}
        </div>
    );
}

export default Table;